import {
  setBackGroundAvatars,
  setProAvatars,
  setUserAvatars,
  setVidboardAvatars,
} from "../../store/avatars/avatarsSlice";
import {
  setLoading,
  setIdle,
  setImageLoading,
} from "../../store/common/appStateSlice";
import {
  fetchDidAvatars,
  fetchDidOnlyAvatars,
  fetchUserAvatar,
  fetchVidboarOnlydAvatars,
  fetchVidboardAvatars,
} from "../../api/avatars";
import { wrapDidAvatars } from "../../utils";
import { getFromLocal } from "../../utils/localStorage";
import { BASE_URL } from "../../api/base";
import { setSlides } from "../../store/slides/slidesSlice";

export const loadVidboardAvatars = () => async (dispatch, getState) => {
  const { isOnlyAvatar } = getState().project;
  try {
    dispatch(setLoading());
    const data = isOnlyAvatar
      ? await fetchVidboarOnlydAvatars()
      : await fetchVidboardAvatars();

    dispatch(setVidboardAvatars(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading vidboard avatars:", error);
    // Handle the error state appropriately, e.g., setting an error state in your store
    dispatch(setIdle());
  }
};

export const loadOnlyAvatarVidboardAvatars = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const data = await fetchVidboarOnlydAvatars();
    dispatch(setBackGroundAvatars(data));
    dispatch(setIdle());
  } catch (error) {
    dispatch(setIdle());
  }
};

export const loadUserAvatars = () => async (dispatch) => {
  try {
    dispatch(setLoading());
    const userId = getFromLocal("userId");
    const data = (await fetchUserAvatar(userId)).map((d) => ({
      ...d,
      image: BASE_URL + "/media/" + d.avatarImage,
    }));
    dispatch(setUserAvatars(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading user avatars:", error);
    // Handle the error state appropriately
    dispatch(setIdle());
  }
};

export const loadProAvatars = () => async (dispatch, getState) => {
  try {
    const { isOnlyAvatar } = getState().project;
    dispatch(setProAvatars([]));
    dispatch(setImageLoading());
    const data = wrapDidAvatars(
      isOnlyAvatar ? await fetchDidOnlyAvatars() : await fetchDidAvatars()
    );
    console.log("loadProavatar", data);
    dispatch(setProAvatars(data));
    dispatch(setIdle());
  } catch (error) {
    console.error("Error loading user avatars:", error);
    // Handle the error state appropriately
    dispatch(setIdle());
  }
};

export const handleAvatarGenderChange =
  (updatedAvatar, canvas) => async (dispatch, getState) => {
    try {
      const { slides } = getState().slides;
      const updatedSlide = slides.map((slide) => {
        slide.objects = [
          ...slide.objects.map((obj) => {
            if (obj.type === "avatar") {
              obj = { ...obj, ...updatedAvatar };
            }
            return obj;
          }),
        ];
        slide.voiceFile = null;
        slide.script = null;
      });
      dispatch(setSlides(updatedSlide));
    } catch (error) {}
  };
